<template>
  <div class="box-seller-registered-info">
    <div class="item">
      <div class="name">国</div>
      <div class="value">{{ seller.countryName }}</div>
    </div>
    <div class="item">
      <div class="name">法人・個人</div>
      <div class="value">{{ seller.corporateKbnStr }}</div>
    </div>
    <div class="item">
      <div class="name">法人番号</div>
      <div class="value">{{ seller.corporateNumber }}</div>
    </div>
    <div class="item">
      <div class="name">インボイス登録番号</div>
      <div class="value">{{ getInvoiceRegistrationNumber(seller) }}</div>
    </div>
    <div class="item">
      <div class="name">[法人]法人名</div>
      <div class="value">{{ seller.companyName }}</div>
    </div>
    <div class="item">
      <div class="name">[法人]法人名フリガナ、または英字</div>
      <div class="value">{{ seller.companyNameEiji }}</div>
    </div>
    <div class="item">
      <div class="name">[法人]代表者名</div>
      <div class="value">{{ seller.companyRepresentativeName }}</div>
    </div>
    <div class="item">
      <div class="name">[法人]代表者名フリガナ、または英字</div>
      <div class="value">{{ seller.companyRepresentativeNameEiji }}</div>
    </div>
    <div class="item">
      <div class="name">[法人]郵便番号</div>
      <div class="value">{{ seller.companyZipCode }}</div>
    </div>
    <div class="item">
      <div class="name">[法人]都道府県</div>
      <div class="value">{{ seller.companyStateName }}</div>
    </div>
    <div class="item">
      <div class="name">[法人]住所</div>
      <div class="value">{{ seller.companyAddress }}</div>
    </div>
    <div class="item">
      <div class="name">[法人]建物名</div>
      <div class="value">{{ seller.companyAddressBuilding }}</div>
    </div>
    <div class="item">
      <div class="name">[法人]代表電話番号</div>
      <div class="value">{{ seller.companyTellNo }}</div>
    </div>
    <div class="item">
      <div class="name">[法人]自社ホームページURL</div>
      <div class="value">{{ seller.companyHpUrl }}</div>
    </div>
    <div class="item">
      <div class="name">[担当]所属部署名</div>
      <div class="value">{{ seller.dept }}</div>
    </div>
    <div class="item">
      <div class="name">[担当]担当者氏名</div>
      <div class="value">{{ seller.sellerName }}</div>
    </div>
    <div class="item">
      <div class="name">[担当]担当者氏名フリガナ、または英字</div>
      <div class="value">{{ seller.sellerNameEiji }}</div>
    </div>
    <div class="item">
      <div class="name">[担当]郵便番号</div>
      <div class="value">{{ seller.zipCode }}</div>
    </div>
    <div class="item">
      <div class="name">[担当]都道府県</div>
      <div class="value">{{ seller.stateName }}</div>
    </div>
    <div class="item">
      <div class="name">[担当]住所</div>
      <div class="value">{{ seller.address }}</div>
    </div>
    <div class="item">
      <div class="name">[担当]建物名</div>
      <div class="value">{{ seller.addressBuilding }}</div>
    </div>
    <div class="item">
      <div class="name">[担当]電話番号</div>
      <div class="value">{{ seller.telNo }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    seller: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    getInvoiceRegistrationNumber (seller) {
      let invoiceRegistrationNoPlan = '0'
      let invoiceRegistrationPlaned = '1'
      let invoiceRegistrationBuyed = '2'
      let invoiceRegistrationKbn = seller.invoiceRegistrationKbn
      let invoiceRegistrationKbnStr = seller.invoiceRegistrationKbnStr
      let invoiceRegistrationDate = seller.invoiceRegistrationDate
      let invoiceRegistrationNumber = seller.invoiceRegistrationNumber

      let str = invoiceRegistrationNumber
      if (invoiceRegistrationKbn === invoiceRegistrationNoPlan) {
        str = invoiceRegistrationKbnStr
      } else if (invoiceRegistrationKbn === invoiceRegistrationPlaned) {
        str = invoiceRegistrationKbnStr + `（${invoiceRegistrationDate}）`
      } else if (invoiceRegistrationKbn === invoiceRegistrationBuyed) {
        str = invoiceRegistrationNumber
      }

      return str
    }
  }
}
</script>
<style scoped>
@media (max-width: 767px) {
  .box-seller-registered-info .item {
    display: block;
    border-bottom: 1px solid #ddd;
    padding: 10px 0px;
  }
  .box-seller-registered-info .item .name {
    width: 100%;
    margin-bottom: 5px;
    min-width: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/setting/userRegisteredInfo/JapanCorporation.vue